import { ThemeConfig, ThemeRegistry } from './types'
import { defaultTheme } from './default.theme'
import { adventureTheme } from './adventure.theme'
import { oceanTheme } from './ocean.theme'
import { sunsetTheme } from './sunset.theme'

class ThemeRegistryImpl implements ThemeRegistry {
  themes: Map<string, ThemeConfig>

  constructor() {
    this.themes = new Map()

    // Register built-in themes
    this.register(defaultTheme)
    this.register(adventureTheme)
    this.register(oceanTheme)
    this.register(sunsetTheme)
  }

  register(theme: ThemeConfig) {
    this.themes.set(theme.id, theme)
  }

  getTheme(id: string): ThemeConfig | undefined {
    return this.themes.get(id)
  }

  getAllThemes(): ThemeConfig[] {
    return Array.from(this.themes.values())
  }
}

// Export singleton instance
export const themeRegistry = new ThemeRegistryImpl()

// Helper function to add custom themes at runtime
export function registerCustomTheme(theme: ThemeConfig) {
  themeRegistry.register(theme)
}
